<template>
  <div class="blog-block blog-text-block">
    <div class="blog-text-block__content" v-html="data.text"></div>
  </div>
</template>

<script>
export default {
  name: 'blog-text-block',

  props: ['data'],
};
</script>

<style lang="scss" scoped>
.blog-text-block {
  width: 100%;

  &__content ::v-deep p {
    padding: 0 calc((100vw / 32) * 2);
    font-size: rem(25px);
    font-size: calc(25px * var(--rw));
    line-height: rem(35px);
    line-height: calc(35px * var(--rw));

    a {
      color: $color-primary;
      text-decoration: underline;
    }

    strong {
      font-weight: bold;
    }
  }
}
</style>
